import { createSlice } from "@reduxjs/toolkit";
import { User } from "./types";
import {
  fetchUsers,
  createUser,
  updateUser,
  deleteUser,
} from "./usersThunks";

interface UsersState {
  users: User[];
  loading: boolean;
  error: string | null;
}

const initialState: UsersState = {
  users: [],
  loading: false,
  error: null,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? "Error fetching users";
      })

      .addCase(createUser.fulfilled, (state, action) => {
        state.users.unshift(action.payload);
      })

      .addCase(updateUser.fulfilled, (state, action) => {
        state.users = state.users.map((u) =>
          u.id === action.payload.id ? action.payload : u
        );
      })

      .addCase(deleteUser.fulfilled, (state, action) => {
        state.users = state.users.filter(
          (u) => u.id !== action.payload
        );
      });
  },
});

export default usersSlice.reducer;
